module.exports = __webpack_public_path__ + "static/protecting-you-faeb39692c7c699cc0e0b5511fd0f6de.png";